<template>
  <div class="min-h-screen bg-gray-50">
    <Header />
    
    <main class="p-6">
      <div class="max-w-7xl mx-auto">
        <!-- Welcome Section -->
        <div class="mb-6">
          <h1 class="text-3xl font-bold text-gray-900">Dashboard</h1>
          <p class="text-gray-600 mt-2">
            Welcome to your Lazily dashboard
            <span v-if="authStore.isAdmin" class="font-medium text-blue-600">(Admin Mode)</span>
          </p>
        </div>

        <!-- Stats Cards -->
        <div class="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          <StatsCard
            title="Total Links"
            :value="linksStore.links.length"
            icon="link"
            color="blue"
          />
          <StatsCard
            title="Total Clicks"
            :value="linksStore.totalClicks"
            icon="mouse-pointer"
            color="green"
          />
          <StatsCard
            title="Active Links"
            :value="linksStore.activeLinks.length"
            icon="check-circle"
            color="green"
          />
        </div>

        <!-- Top Links Section -->
        <div class="card mb-12">
          <div class="card-header">
            <h2 class="text-xl font-semibold text-gray-900">Top Performing Links</h2>
          </div>
          <div class="card-body">
            <TopLinksCard />
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { useLinksStore } from '@/stores/links'
import Header from '@/components/common/Header.vue'
import StatsCard from '@/components/dashboard/StatsCard.vue'
import TopLinksCard from '@/components/dashboard/TopLinksCard.vue'

const authStore = useAuthStore()
const linksStore = useLinksStore()

onMounted(async () => {
  try {
    await Promise.all([
      linksStore.fetchLinks({ limit: 50 }),
      linksStore.fetchTopLinks(10)
    ])
  } catch (error) {
    console.error('Failed to load dashboard data:', error)
  }
})
</script>
